<template>
  <quote :message="message"></quote>
</template>

<script>
  export default {
    data() {
      return {
        message: `
          <small style='margin-bottom: 10px; display: block'>
            1 = Light. Lees prevented from settling
          </small>
          <small style='margin-bottom: 10px; display: block'>
            2 = Moderate. Some vertical mixing
          </small>
          <small>
            3 = Strong. Good mixing between top and bottom of tank
          </small>
        `
      }
    }
  }
</script>



// WEBPACK FOOTER //
// agitator-definition.vue?9f3eb2b8